export default {"src":"/_next/static/media/roadwise-financing-logo-dark-en.4ac6ffda.svg","height":47,"width":109,"blurWidth":0,"blurHeight":0};